module.exports = __webpack_public_path__ + "img/logo_new.6db60f0a.svg";